
import { CompanyCatCd } from '@/enum'

export default {
  methods: {
    /**
     * 検査可能な会社であるか判定
     */
    isInspectableCompany(inspCompanyCd, inspCompanyCatCd) {
      let result = false

      if (this.$store.getters.isEpson && inspCompanyCatCd == CompanyCatCd.EPSON) {
        result = true
      } else if (this.$store.getters.isSupplier && inspCompanyCd == this.$store.getters.companyCd) {
        result = true
      }

      return result
    },
  },
}
